import { observer } from 'mobx-react-lite'

import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

import { useAppConfig, useSettingsStore } from '../../common'

import ProfileTab from './profile/ProfileTab'
import DeviceTab from './devices/DeviceTab'
import TransactionRulesTab from './transactionrules/TransactionRulesTab'
import { NotificationSettings } from './notifications/NotificationSettings'
import { SettingsTabs } from '../SettingsWidget'
import { Help } from '../../help'
import Stack from '@mui/material/Stack'

interface SettingsWidgetContentsProps {
  selectedTab: SettingsTabs
}

export const SettingsWidgetContents = observer(({ selectedTab }: SettingsWidgetContentsProps) => {
  const { alert, setAlert } = useSettingsStore()
  const {
    config: { display_user_profile_in_settings },
  } = useAppConfig()

  return (
    <>
      {selectedTab === SettingsTabs.Profile && <ProfileTab />}
      {selectedTab === SettingsTabs.Devices && <DeviceTab />}
      {selectedTab === SettingsTabs.Notifications && (
        <NotificationSettings showPersonalDetails={!display_user_profile_in_settings} />
      )}
      {selectedTab === SettingsTabs.TransactionRules && <TransactionRulesTab />}
      {selectedTab === SettingsTabs.Help && (
        <Stack sx={{ px: 24 }}>
          <Help />
        </Stack>
      )}

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={3500}
        onClose={() => setAlert('')}
        open={Boolean(alert.message)}
      >
        <Alert
          onClose={() => {
            setAlert('')
          }}
          severity={alert.severity}
          variant="filled"
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </>
  )
})
